(function () {
  'use strict';

  var sizeFilterName = 'filter.p.m.custom.case_measurement_';
  var priorities = {
    availability: 0,
    collection: 1,
    movement: 2,
    'movement type': 2,
    'case measurement': 3,
    'case size': 3,
    size: 3,
    dial: 4,
    material: 5,
    gender: 6,
    price: 7
  };

  var sizeRanges = [
    { id: '19-27', label: '19-27mm', min: 0, max: 28 },
    { id: '28-29', label: '28-29mm', min: 28, max: 30 },
    { id: '30-31', label: '30-31mm', min: 30, max: 32 },
    { id: '32-33', label: '32-33mm', min: 32, max: 34 },
    { id: '34-35', label: '34-35mm', min: 34, max: 36 },
    { id: '36-37', label: '36-37mm', min: 36, max: 38 },
    { id: '38-39', label: '38-39mm', min: 38, max: 40 },
    { id: '40-41', label: '40-41mm', min: 40, max: 42 },
    { id: '42-43', label: '42-43mm', min: 42, max: 44 },
    { id: '44-45', label: '44-45mm', min: 44, max: 46 },
    { id: '46-47', label: '46-47mm', min: 46, max: 48 },
    { id: '48-plus', label: '48mm+', min: 48, max: Infinity }
  ];

  var collectionFilterName = 'filter.p.m.custom.collection';
  var collectionGroups = [
    { id: '1926', label: '1926', values: ['TUDOR 1926'] },
    { id: 'black-bay-54', label: 'Black Bay 54', values: ['TUDOR Black Bay 54'] },
    { id: 'black-bay-58', label: 'Black Bay 58', values: ['TUDOR Black Bay 58', 'TUDOR Black Bay 58 18K', 'TUDOR Black Bay 58 925', 'TUDOR Black Bay 58 Bronze'] },
    { id: 'black-bay-68', label: 'Black Bay 68', values: ['TUDOR Black Bay 68'] },
    { id: 'black-bay-bronze', label: 'Black Bay Bronze', values: ['TUDOR Black Bay Bronze'] },
    { id: 'black-bay-chrono', label: 'Black Bay Chrono', values: ['TUDOR Black Bay Chrono', 'TUDOR Black Bay Chrono S&G'] },
    { id: 'black-bay-gmt', label: 'Black Bay GMT', values: ['TUDOR Black Bay 58 GMT', 'TUDOR Black Bay GMT', 'TUDOR Black Bay GMT S&G'] },
    { id: 'black-bay-one', label: 'Black Bay One', values: ['TUDOR Black Bay One 31', 'TUDOR Black Bay One 31 S&G', 'TUDOR Black Bay One 36', 'TUDOR Black Bay One 36 S&G', 'TUDOR Black Bay One 39', 'TUDOR Black Bay One 39 S&G', 'TUDOR Black Bay One 41', 'TUDOR Black Bay One 41 S&G'] },
    { id: 'black-bay-pro', label: 'Black Bay Pro', values: ['TUDOR Black Bay Pro'] },
    { id: 'black-bay', label: 'Black Bay', values: ['TUDOR Black Bay', 'TUDOR Black Bay Ceramic'] },
    { id: 'clair-de-rose', label: 'Clair de Rose', values: ['TUDOR Clair de Rose'] },
    { id: 'pelagos-fxd', label: 'Pelagos FXD', values: ['TUDOR Pelagos FXD', 'TUDOR Pelagos FXD Chrono', 'TUDOR Pelagos FXD GMT'] },
    { id: 'pelagos', label: 'Pelagos', values: ['TUDOR Pelagos', 'TUDOR Pelagos 39', 'TUDOR Pelagos LHD', 'TUDOR Pelagos Ultra'] },
    { id: 'ranger', label: 'Ranger', values: ['TUDOR Ranger'] },
    { id: 'tudor-monarch', label: 'TUDOR Monarch', values: ['TUDOR Monarch'] },
    { id: 'tudor-royal', label: 'TUDOR Royal', values: ['TUDOR Royal'] }
  ];

  function normalizedLabel(button) {
    return (button && button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function replaceButtonText(button, nextText) {
    var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    var textNode = walker.nextNode();
    while (textNode && !textNode.textContent.trim()) textNode = walker.nextNode();
    if (textNode) textNode.textContent = nextText + ' ';
  }

  function unique(values) {
    return values.filter(function (value, index, array) { return array.indexOf(value) === index; });
  }

  function widthFromValue(value) {
    var normalized = String(value || '').trim();
    var measurementMatch = normalized.match(/\b(?:diameter|width)\s*(\d+(?:\.\d+)?)/i);
    if (measurementMatch) return Number(measurementMatch[1]);
    var leadingMatch = normalized.match(/^(\d+(?:\.\d+)?)/);
    return leadingMatch ? Number(leadingMatch[1]) : NaN;
  }

  function isGroupedFilterValue(value) {
    return /^gid:\/\/shopify\/FilterSettingGroup\//.test(String(value || ''));
  }

  function selectedSizeValues() {
    return new URL(window.location.href).searchParams.getAll(sizeFilterName);
  }

  function applySizeSelection(list) {
    var values = [];
    list.querySelectorAll('input[type="checkbox"]:checked').forEach(function (checkbox) {
      values = values.concat(checkbox.gtjSizeValues || []);
    });
    var url = new URL(window.location.href);
    url.searchParams.delete(sizeFilterName);
    unique(values).forEach(function (value) { url.searchParams.append(sizeFilterName, value); });
    url.searchParams.delete('page');
    document.documentElement.classList.add('gtj-size-filter-loading');
    window.location.assign(url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
  }

  function sizeRangeForValue(value) {
    var width = widthFromValue(value);
    return sizeRanges.find(function (range) { return width >= range.min && width < range.max; });
  }

  function hrefWithoutSizeRange(selected, range) {
    var remaining = selected.filter(function (value) { return sizeRangeForValue(value) !== range; });
    var url = new URL(window.location.href);
    url.searchParams.delete(sizeFilterName);
    unique(remaining).forEach(function (value) { url.searchParams.append(sizeFilterName, value); });
    url.searchParams.delete('page');
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }

  function enhanceActiveSizeTags() {
    var url = new URL(window.location.href);
    var selected = url.searchParams.getAll(sizeFilterName);
    if (!selected.length) return;
    if (selected.some(isGroupedFilterValue)) return;
    var selectedRanges = sizeRanges.filter(function (range) {
      return selected.some(function (value) { return sizeRangeForValue(value) === range; });
    });

    document.querySelectorAll('.tag-list--active-tags').forEach(function (list) {
      list.querySelectorAll('a[href*="' + sizeFilterName + '"]').forEach(function (link) {
        var tag = link.closest('li') || link.parentNode;
        if (tag) { tag.hidden = true; tag.classList.add('gtj-size-filter__native-active-tag'); }
      });
      list.querySelectorAll('.gtj-size-filter__active-tag').forEach(function (tag) { tag.remove(); });
      selectedRanges.forEach(function (range) {
        var item = document.createElement('li');
        item.className = 'tag tag--remove gtj-size-filter__active-tag';
        var link = document.createElement('a');
        link.className = 'btn btn--small';
        link.href = hrefWithoutSizeRange(selected, range);
        link.setAttribute('aria-label', 'Remove size ' + range.label + ' filter');
        link.appendChild(document.createTextNode(range.label));
        var remove = document.createElement('span');
        remove.className = 'gtj-size-filter__active-remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.textContent = '×';
        link.appendChild(remove);
        item.appendChild(link);
        list.appendChild(item);
      });
    });
  }

  function buildSizeFilter(group) {
    group.classList.add('gtj-size-filter-group');
    if (group.dataset.gtjSizeEnhanced === 'true') return;
    var nativeInputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"][name="' + sizeFilterName + '"]'));
    if (!nativeInputs.length) return;
    var nativeList = nativeInputs[0].closest('ul');
    var mount = nativeList ? nativeList.parentNode : group.querySelector('.collapsible-content__inner') || group;
    if (nativeInputs.some(function (input) { return isGroupedFilterValue(input.value); })) {
      group.classList.add('gtj-size-filter-group--native');
      if (nativeList) {
        nativeList.classList.add('gtj-size-filter');
        nativeList.setAttribute('aria-label', 'Filter watches by case size');
      }
      nativeInputs.forEach(function (input) {
        input.classList.add('gtj-size-filter__checkbox');
        var label = input.closest('label');
        if (label) label.classList.add('gtj-size-filter__label');
      });
      group.dataset.gtjSizeEnhanced = 'true';
      return;
    }
    if (nativeList) { nativeList.hidden = true; nativeList.setAttribute('aria-hidden', 'true'); nativeList.classList.add('gtj-size-filter__native'); }
    var available = unique(nativeInputs.map(function (input) { return input.value; })).filter(function (value) { return !Number.isNaN(widthFromValue(value)); });
    var selected = selectedSizeValues();
    var list = document.createElement('ul');
    list.className = 'gtj-size-filter';
    list.setAttribute('aria-label', 'Filter watches by case size');

    sizeRanges.forEach(function (range) {
      var values = available.filter(function (value) { var width = widthFromValue(value); return width >= range.min && width < range.max; });
      if (!values.length) return;
      var item = document.createElement('li');
      item.className = 'gtj-size-filter__option';
      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'gtj-size-filter__checkbox';
      checkbox.id = 'gtj-size-' + range.id + '-' + Math.random().toString(36).slice(2, 8);
      checkbox.checked = values.some(function (value) { return selected.indexOf(value) !== -1; });
      checkbox.gtjSizeValues = values;
      var label = document.createElement('label');
      label.className = 'gtj-size-filter__label';
      label.htmlFor = checkbox.id;
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(range.label));
      checkbox.addEventListener('change', function (event) { event.preventDefault(); event.stopPropagation(); if (event.stopImmediatePropagation) event.stopImmediatePropagation(); applySizeSelection(list); });
      item.appendChild(label);
      list.appendChild(item);
    });
    mount.appendChild(list);
    group.dataset.gtjSizeEnhanced = 'true';
  }


  function selectedCollectionValues() {
    return new URL(window.location.href).searchParams.getAll(collectionFilterName);
  }

  function collectionGroupForValue(value) {
    return collectionGroups.find(function (group) { return group.values.indexOf(value) !== -1; });
  }

  function applyCollectionSelection(list) {
    var values = [];
    list.querySelectorAll('.gtj-collection-filter__checkbox:checked').forEach(function (checkbox) {
      values = values.concat(checkbox.gtjCollectionValues || []);
    });
    var url = new URL(window.location.href);
    url.searchParams.delete(collectionFilterName);
    unique(values).forEach(function (value) { url.searchParams.append(collectionFilterName, value); });
    url.searchParams.delete('page');
    document.documentElement.classList.add('gtj-collection-filter-loading');
    window.location.assign(url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash);
  }

  function hrefWithoutCollectionGroup(selected, group) {
    var remaining = selected.filter(function (value) { return group.values.indexOf(value) === -1; });
    var url = new URL(window.location.href);
    url.searchParams.delete(collectionFilterName);
    unique(remaining).forEach(function (value) { url.searchParams.append(collectionFilterName, value); });
    url.searchParams.delete('page');
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }

  function enhanceActiveCollectionTags() {
    var selected = selectedCollectionValues();
    if (!selected.length) return;
    var selectedGroups = collectionGroups.filter(function (group) {
      return selected.some(function (value) { return group.values.indexOf(value) !== -1; });
    });

    document.querySelectorAll('.tag-list--active-tags').forEach(function (list) {
      list.querySelectorAll('a[href*="' + collectionFilterName + '"]').forEach(function (link) {
        var tag = link.closest('li') || link.parentNode;
        if (tag) { tag.hidden = true; tag.classList.add('gtj-collection-filter__native-active-tag'); }
      });
      list.querySelectorAll('.gtj-collection-filter__active-tag').forEach(function (tag) { tag.remove(); });
      selectedGroups.forEach(function (group) {
        var item = document.createElement('li');
        item.className = 'tag tag--remove gtj-collection-filter__active-tag';
        var link = document.createElement('a');
        link.className = 'btn btn--small';
        link.href = hrefWithoutCollectionGroup(selected, group);
        link.setAttribute('aria-label', 'Remove collection ' + group.label + ' filter');
        link.appendChild(document.createTextNode(group.label));
        var remove = document.createElement('span');
        remove.className = 'gtj-collection-filter__active-remove';
        remove.setAttribute('aria-hidden', 'true');
        remove.textContent = '×';
        link.appendChild(remove);
        item.appendChild(link);
        list.appendChild(item);
      });
    });
  }

  function buildCollectionFilter(group) {
    group.classList.add('gtj-collection-filter-group');
    if (group.dataset.gtjCollectionEnhanced === 'true') return;
    var nativeInputs = Array.prototype.slice.call(group.querySelectorAll('input[type="checkbox"][name="' + collectionFilterName + '"]'));
    if (!nativeInputs.length) return;
    var nativeList = nativeInputs[0].closest('ul');
    var mount = nativeList ? nativeList.parentNode : group.querySelector('.collapsible-content__inner') || group;
    if (nativeList) {
      nativeList.hidden = true;
      nativeList.setAttribute('aria-hidden', 'true');
      nativeList.classList.add('gtj-collection-filter__native');
    }

    var available = unique(nativeInputs.map(function (input) { return input.value; }));
    var selected = selectedCollectionValues();
    var list = document.createElement('ul');
    list.className = 'gtj-collection-filter';
    list.setAttribute('aria-label', 'Filter Tudor watches by collection');

    collectionGroups.forEach(function (collectionGroup) {
      var values = collectionGroup.values.filter(function (value) {
        return available.indexOf(value) !== -1 || selected.indexOf(value) !== -1;
      });
      if (!values.length) return;
      var item = document.createElement('li');
      item.className = 'gtj-collection-filter__option';
      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'gtj-collection-filter__checkbox';
      checkbox.id = 'gtj-tudor-collection-' + collectionGroup.id + '-' + Math.random().toString(36).slice(2, 8);
      var selectedCount = collectionGroup.values.filter(function (value) { return selected.indexOf(value) !== -1; }).length;
      checkbox.checked = selectedCount > 0;
      checkbox.indeterminate = selectedCount > 0 && selectedCount < collectionGroup.values.length;
      checkbox.gtjCollectionValues = collectionGroup.values.slice();
      var label = document.createElement('label');
      label.className = 'gtj-collection-filter__label';
      label.htmlFor = checkbox.id;
      label.appendChild(checkbox);
      label.appendChild(document.createTextNode(collectionGroup.label));
      checkbox.addEventListener('change', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        checkbox.indeterminate = false;
        applyCollectionSelection(list);
      });
      item.appendChild(label);
      list.appendChild(item);
    });

    mount.appendChild(list);
    group.dataset.gtjCollectionEnhanced = 'true';
  }

  function enhanceForm(form) {
    var groups = Array.prototype.slice.call(form.children).filter(function (child) { return child.className && String(child.className).indexOf('collection-sidebar__group--') !== -1; });
    groups.forEach(function (group) {
      var button = group.querySelector('.collapsible-trigger');
      var label = normalizedLabel(button);
      if (label === 'brand' || label === 'category') { group.hidden = true; group.setAttribute('aria-hidden', 'true'); group.dataset.gtjFilterPriority = '99'; return; }
      group.hidden = false;
      group.removeAttribute('aria-hidden');
      if (label === 'case measurement' || label === 'case size') { replaceButtonText(button, 'Size'); label = 'size'; }
      if (label === 'movement type') { replaceButtonText(button, 'Movement'); label = 'movement'; }
      if (label === 'size') buildSizeFilter(group);
      if (label === 'collection') buildCollectionFilter(group);
      group.dataset.gtjFilterPriority = String(Object.prototype.hasOwnProperty.call(priorities, label) ? priorities[label] : 50);
    });
    groups.slice().sort(function (a, b) { return Number(a.dataset.gtjFilterPriority) - Number(b.dataset.gtjFilterPriority); }).forEach(function (group) { form.appendChild(group); });
  }

  var scheduled = false;
  var observer = null;

  function observeFilters() {
    if (!observer) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function enhanceFilters() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      if (observer) observer.disconnect();
      document.querySelectorAll('.filter-form').forEach(enhanceForm);
      enhanceActiveSizeTags();
      enhanceActiveCollectionTags();
      observeFilters();
    }, 0);
  }

  function init() {
    observer = new MutationObserver(enhanceFilters);
    observeFilters();
    enhanceFilters();
    document.addEventListener('shopify:section:load', enhanceFilters);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
